<template>
  <div>
    <div class="section-title" style="text-align: center; margin: 40px 0;">
      Płatność
    </div>
    <v-container class="container mt-10 mb-12 pb-12" fluid>
      <v-row justify="center" align="baseline">
        <v-col cols="12" sm="6" md="4" lg="4" xl="3">
          <v-card shaped elevation="5" class="card">
            <v-container v-if="packageData" class="">
              <div v-if="hasWorkshopsAvailablePlaces">
                <PaymentForm
                  :profile="profile"
                  :selectedPackage="packageData"
                  :isExtendedSubscription="isExtendedSubscription"
                >
                </PaymentForm>
              </div>
              <div v-else>
                <p style="text-align: center; padding-top: 20px;">
                  Niestety, do warsztatów
                  <span style="font-weight: 600">{{
                    noAvailableWorkshopsName
                  }}</span>
                  zapisała się już maksymalna liczba uczestników
                </p>
                <div
                  class="pb-10"
                  style="display: flex;align-items: center; justify-content: center;"
                >
                  <button class="primary-button" @click="redirectBack">
                    Rozumiem
                  </button>
                </div>
              </div>
            </v-container>

            <v-container v-else>
              <h1 class="text-center">404</h1>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PaymentForm from "../components/forms/PaymentForm.vue";
import router from "../router";

export default {
  metaInfo: {
    title: "Dagajoga kurs online - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej.\nPraktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
    ],
  },
  name: "WorkshopsPayment",
  components: {
    PaymentForm,
  },
  data: () => ({
    noAvailableWorkshopsName: "",
    hasWorkshopsAvailablePlaces: false,
  }),
  computed: {
    packageData: function() {
      return this.$store.getters["workshops/getSelectedWorkshopsForPayment"];
    },
    profile() {
      return this.$store.getters["auth/getProfile"];
    },
    isExtendedSubscription() {
      return this.$route.query.rozszerzona == "1";
    },
  },
  async mounted() {
    await this.$store.dispatch("auth/fetchUserProfile");

    await this.$store.dispatch(
      "workshops/fetchWorkshop",
      this.$route.params.id
    );

    const hasWorkshopsAvailablePlaces = this.packageData.hasAvailablePlaces;

    if (!hasWorkshopsAvailablePlaces) {
      this.noAvailableWorkshopsName = this.packageData.notAvailablePlacesName;
      this.hasWorkshopsAvailablePlaces = hasWorkshopsAvailablePlaces;
    } else {
      this.hasWorkshopsAvailablePlaces = hasWorkshopsAvailablePlaces;
      if (this.packageData.type && this.packageData.type === "WORKSHOPS") {
        const token = window.localStorage.getItem("userToken");
        if (!token) {
          this.$store.dispatch(
            "snackbar/setSnackbar",
            {
              color: "red",
              icon: "exclamation-triangle",
              message:
                "Zakup warsztatów dostępny jest wyłącznie dla zalogowanych użytkowników",
            },
            { root: true }
          );
          this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
          this.$router.push({
            name: "Auth",
            params: {
              previousPath: `/warsztaty/platnosc/${this.$route.params.id}`,
            },
          });
        }
      }
    }
  },
  destroyed() {
    this.$store.commit("payment/SET_INIT_VALUES");
  },
  methods: {
    redirectBack() {
      const backToLink = this.packageData.descriptionLink;
      if (backToLink) {
        window.location.replace(backToLink);
      } else {
        router.push({ name: "Workshops" });
      }
    },
  },
};
</script>

<style scoped>
.reset {
  text-transform: uppercase;
  cursor: pointer;
}
.submit-button {
  background-color: #8b857d !important;
  border-radius: 20px;
  font-size: 1.1rem;
  color: #d9d9d9;
  margin: auto;
  display: flex;
  justify-content: center;
}
.card {
  background: #d9d9d9;
  border-radius: 20px !important;
  box-shadow: 0px 0px 100px 25px #b6afa5 !important;
  color: #8b857d;
}
.agreements p {
  font-size: 12px;
}
</style>
